import $ from 'jquery';
var I18n = require('i18n-react').default;

function toggleLoadingModal() {
  $('#loader-message').text(I18n.translate('loading'));
  window.showLoadingScreen();
}

export function fetchLoader(url, options = {}) {
  toggleLoadingModal();

  return fetch(url, options)
    .then(response => {
      toggleLoadingModal();
      return response;
    })
    .catch(() => {
      toggleLoadingModal();
    });
}

export function multipleFetchLoader(promises) {
  toggleLoadingModal();
  return Promise.all(promises)
    .then(response => {
      toggleLoadingModal();
      return response;
    })
    .catch(() => {
      toggleLoadingModal();
      throw Error();
    });
}



// WEBPACK FOOTER //
// ./src/components/utils/FetchLoader.js